import userProfileReducer from '../modules/userprofile/reducers/userprofilereducer';
import miCoreSharedReducer from '../modules/micorecomponents/reducers/micoresharedreducer';
import reportEngineReducer from '../modules/reportengine/reducers/reportenginereducer'
import bulkPhotoUpload from '../modules/bulkphotoupload/reducers/bulkphotouploadreducer'
import transactionReducer from '../modules/transactions/reducer/transactionReducer';
//admin
import adminReducer from '../modules/admin/reducers/adminreducer'
import miCustomerSharedReducer from '../modules/MICustomer/reducers/micustomerreducer';
import complaintandfeedbackReducer from '../modules/ComplaintsAndFeedback/reducers/complaintandfeedbackreducer'
import communicationModuleReducer from '../modules/communicationmodule/reducers/communicationmodulereducer'


export default function getReducers() {
  return {
      adminReducer: adminReducer,
      reportEngineReducer: reportEngineReducer,
      userProfileReducer: userProfileReducer,
      miCoreSharedReducer:miCoreSharedReducer,
      bulkPhotoUpload: bulkPhotoUpload,
      transactionReducer: transactionReducer,
      miCustomerSharedReducer:miCustomerSharedReducer,
      complaintandfeedbackReducer: complaintandfeedbackReducer,
        communicationModuleReducer: communicationModuleReducer
  };
}